import { useStore } from '../store/useStore';

export function showToast(
  message: string,
  type: 'success' | 'error' | 'info' | 'warning' = 'error'
) {
  useStore.getState().addToast(message, type);
}
